module.exports = __webpack_public_path__ + "static/img/eco-protection-03.d283473.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/csr/eco-protection/eco-protection-03.jpg
// module id = 4Zsv
// module chunks = 99